// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ------------------------------------------------------------------------
 * @author      CEBS Worldwide
 * @copyright   � 2025 CEBS Worldwide. All rights reserved.
 * @license     STRICTLY CONFIDENTIAL
 * ------------------------------------------------------------------------ */

.emirates-dashboard-container {
  padding: 1.5rem;
  background-color: #f8f9fc;
  flex-grow: 1;
  min-height: 100vh;
}

.filter-bar {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
}

.filter-bar select,
.filter-bar button {
  padding: 0.5rem 1rem;
  font-size: 0.95rem;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.filter-bar button {
  background-color: #0066cc;
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.filter-bar button:hover {
  background-color: #004d99;
}

.cards-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));
  gap: 1.5rem;
}

.chart-card {
  background-color: white;
  border-radius: 12px;
  padding: 1rem 1.5rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.chart-card h4 {
  margin-bottom: 0.8rem;
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
}

.chart-description {
  font-size: 0.85rem;
  margin-top: 0.75rem;
  color: #555;
  text-align: center;
}

/* Responsive Fix */
@media screen and (max-width: 768px) {
  .filter-bar {
    flex-direction: column;
    align-items: flex-start;
  }

  .cards-container {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/demo/emirates/EmiratesDashboard.css"],"names":[],"mappings":"AAAA;;;;6EAI6E;;AAE7E;EACE,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* ------------------------------------------------------------------------\n * @author      CEBS Worldwide\n * @copyright   � 2025 CEBS Worldwide. All rights reserved.\n * @license     STRICTLY CONFIDENTIAL\n * ------------------------------------------------------------------------ */\n\n.emirates-dashboard-container {\n  padding: 1.5rem;\n  background-color: #f8f9fc;\n  flex-grow: 1;\n  min-height: 100vh;\n}\n\n.filter-bar {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n}\n\n.filter-bar select,\n.filter-bar button {\n  padding: 0.5rem 1rem;\n  font-size: 0.95rem;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n}\n\n.filter-bar button {\n  background-color: #0066cc;\n  color: white;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.filter-bar button:hover {\n  background-color: #004d99;\n}\n\n.cards-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));\n  gap: 1.5rem;\n}\n\n.chart-card {\n  background-color: white;\n  border-radius: 12px;\n  padding: 1rem 1.5rem;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n}\n\n.chart-card h4 {\n  margin-bottom: 0.8rem;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #333;\n}\n\n.chart-description {\n  font-size: 0.85rem;\n  margin-top: 0.75rem;\n  color: #555;\n  text-align: center;\n}\n\n/* Responsive Fix */\n@media screen and (max-width: 768px) {\n  .filter-bar {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .cards-container {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
